export default [
  {
    'id': 'pickup',
    'type': 'Pick up'
  },
  {
    'id': 'halfway',
    'type': 'Meet me half way'
  },
  {
    'id': 'athome',
    'type': 'At home'
  },
  {
    'id': 'location',
    'type': 'Consume on location'
  }
]



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/DeliveryService/services.js